module.exports = __webpack_public_path__ + "static/media/bg.7fbf1358.jpg";